<div class="grid">
  <!-- Link unusable: expired, unknown or missing from the URL -->
  <ng-container *ngIf="linkExpired || linkMissing">
    <h2>{{ "pages.passwordReset.expiredTitle" | translate }}</h2>
    <h5>{{ "pages.passwordReset.expiredDescription" | translate }}</h5>

    <ng-container *ngIf="!resendSuccess">
      <input
        nbInput
        fullWidth
        type="email"
        [(ngModel)]="resendEmail"
        name="resendEmail"
        [placeholder]="'pages.passwordReset.emailPlaceholder' | translate"
      />
      <p class="caption status-danger" *ngIf="resendError">
        {{ resendError | translate }}
      </p>
      <button
        nbButton
        status="primary"
        [nbSpinner]="resendLoading"
        nbSpinnerStatus="control"
        [disabled]="!resendEmail || resendLoading"
        (click)="requestNewLink()"
      >
        {{ "pages.passwordReset.resendButton" | translate }}
      </button>
    </ng-container>

    <p class="status-success" *ngIf="resendSuccess">
      {{ "pages.passwordReset.resendSuccess" | translate }}
    </p>
  </ng-container>

  <!-- Done -->
  <ng-container *ngIf="success">
    <h2>{{ "pages.passwordReset.successTitle" | translate }}</h2>
    <h5>{{ "pages.passwordReset.successDescription" | translate }}</h5>
    <button nbButton status="primary" (click)="toLogin()">
      {{ "buttons.toLogin" | translate }}
    </button>
  </ng-container>

  <!-- The form -->
  <form
    *ngIf="!linkExpired && !linkMissing && !success"
    (ngSubmit)="submit()"
    #resetForm="ngForm"
  >
    <h2>{{ "pages.passwordReset.title" | translate }}</h2>
    <h5>{{ "pages.passwordReset.description" | translate }}</h5>

    <nb-alert *ngIf="error" outline="danger" role="alert">
      {{ error | translate }}
    </nb-alert>

    <label class="label" for="input-password">
      {{ "pages.passwordReset.newPassword" | translate }}
    </label>
    <input
      nbInput
      fullWidth
      id="input-password"
      name="password"
      [type]="showPassword ? 'text' : 'password'"
      [(ngModel)]="password"
      autocomplete="new-password"
      autofocus
      [placeholder]="'pages.passwordReset.newPassword' | translate"
    />

    <label class="label" for="input-confirm">
      {{ "pages.passwordReset.confirmPassword" | translate }}
    </label>
    <input
      nbInput
      fullWidth
      id="input-confirm"
      name="confirmPassword"
      [type]="showPassword ? 'text' : 'password'"
      [(ngModel)]="confirmPassword"
      autocomplete="new-password"
      [status]="passwordsMatch ? 'basic' : 'danger'"
      [placeholder]="'pages.passwordReset.confirmPassword' | translate"
    />
    <p class="caption status-danger" *ngIf="!passwordsMatch">
      {{ "pages.passwordReset.errors.password_mismatch" | translate }}
    </p>

    <nb-checkbox [(ngModel)]="showPassword" name="showPassword">
      {{ "pages.passwordReset.showPassword" | translate }}
    </nb-checkbox>

    <!-- The rules, stated up front and ticked off as they are met -->
    <div class="requirements">
      <p class="requirements-title">
        {{ "pages.passwordReset.requirementsTitle" | translate }}
      </p>
      <ul>
        <li *ngFor="let rule of rules" [class.met]="ruleMet(rule)">
          <nb-icon
            [icon]="ruleMet(rule) ? 'checkmark-circle-2' : 'radio-button-off'"
            [status]="ruleMet(rule) ? 'success' : 'basic'"
          ></nb-icon>
          <span>{{ "pages.passwordReset.rules." + rule.key | translate }}</span>
        </li>
      </ul>
    </div>

    <button
      nbButton
      status="primary"
      type="submit"
      fullWidth
      [nbSpinner]="loading"
      nbSpinnerStatus="control"
      [disabled]="!canSubmit"
    >
      {{ "pages.passwordReset.submit" | translate }}
    </button>
  </form>
</div>
